/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_License_QuestionInputs */

const en_landing_faq_license_question = /** @type {(inputs: Landing_Faq_License_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I use this for commercial projects?`)
};

const zh_landing_faq_license_question = /** @type {(inputs: Landing_Faq_License_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以用于商业项目吗？`)
};

/**
* | output |
* | --- |
* | "Can I use this for commercial projects?" |
*
* @param {Landing_Faq_License_QuestionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_faq_license_question = /** @type {((inputs?: Landing_Faq_License_QuestionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_License_QuestionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_faq_license_question(inputs)
	return zh_landing_faq_license_question(inputs)
});
export { landing_faq_license_question as "landing.faq.license.question" }